import styled from "styled-components";
import Text from "../Text";

export const StyledHeaderText = styled(Text)`
  line-height: 1;
`;
